import '@cds/core/icon/register.js';
import { ClarityIcons, pencilIcon, trashIcon, exclamationCircleIcon,
          bubbleExclamationIcon, exclamationTriangleIcon, eyeIcon, playIcon,
          copyIcon, checkCircleIcon, checkIcon, arrowIcon,
          infoStandardIcon,
          curveChartIcon,
          exportIcon,
          envelopeIcon,
          digitalSignatureIcon,
          floppyIcon,
          importIcon,
          timesIcon,
          plusIcon,
          historyIcon} from '@cds/core/icon';

ClarityIcons.addIcons(pencilIcon);
ClarityIcons.addIcons(trashIcon);
ClarityIcons.addIcons(exclamationCircleIcon);
ClarityIcons.addIcons(exclamationTriangleIcon);
ClarityIcons.addIcons(bubbleExclamationIcon);
ClarityIcons.addIcons(eyeIcon);
ClarityIcons.addIcons(playIcon);
ClarityIcons.addIcons(checkIcon);
ClarityIcons.addIcons(checkCircleIcon);
ClarityIcons.addIcons(arrowIcon);
ClarityIcons.addIcons(copyIcon);
ClarityIcons.addIcons(infoStandardIcon);
ClarityIcons.addIcons(curveChartIcon);
ClarityIcons.addIcons(exportIcon);
ClarityIcons.addIcons(envelopeIcon);
ClarityIcons.addIcons(digitalSignatureIcon);
ClarityIcons.addIcons(floppyIcon);
ClarityIcons.addIcons(importIcon);
ClarityIcons.addIcons(timesIcon);
ClarityIcons.addIcons(plusIcon);
ClarityIcons.addIcons(historyIcon);
